import { render, staticRenderFns } from "./ProductTitle.vue?vue&type=template&id=4edf8b0f&"
import script from "./ProductTitle.vue?vue&type=script&lang=js&"
export * from "./ProductTitle.vue?vue&type=script&lang=js&"
import style0 from "./ProductTitle.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default})
